import React from 'react';

const OrdersEditor = () => {
  return <div></div>;
};

export default OrdersEditor;
